import { currentTierIIReportingYear } from "encamp-shared/src/constants/tierii";

export function buildWasteFacilityUrl(tenantId: string, facilityId: string): string {
  const year = currentTierIIReportingYear;
  return `/o/${tenantId}/waste/facilities/${facilityId}?startDate=${year}-01-01&endDate=${year}-12-31&view=REPORTABLE`;
}
